module.exports = __webpack_public_path__ + "static/img/ls2.ff641d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls2.png
// module id = kUgi
// module chunks = 12